import { useEffect, useRef } from "react";

export default function CanvasSnow() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const width = (canvas.width = window.innerWidth);
    const height = (canvas.height = window.innerHeight);

    ctx.clearRect(0, 0, width, height);

    // Sky
    ctx.fillStyle = "#E0F7FA"; // Light icy blue
    ctx.fillRect(0, 0, width, height);

    // Snowy ground
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, height * 0.6, width, height * 0.4);

    // Igloo
    const iglooX = width * 0.75;
    const iglooY = height * 0.75;
    const iglooRadius = 200;

    // Dome
    ctx.beginPath();
    ctx.fillStyle = "#E0E0E0";
    ctx.arc(iglooX, iglooY, iglooRadius, Math.PI, 0);
    ctx.lineTo(iglooX + iglooRadius, iglooY);
    ctx.lineTo(iglooX - iglooRadius, iglooY);
    ctx.closePath();
    ctx.fill();

    // Entrance
    ctx.beginPath();
    ctx.fillStyle = "#B0BEC5";
    ctx.arc(iglooX - 40, iglooY + 10, 20, Math.PI, 0);
    ctx.lineTo(iglooX - 20, iglooY + 10);
    ctx.lineTo(iglooX - 60, iglooY + 10);
    ctx.closePath();
    ctx.fill();
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
    />
  );
}
